export default function createPaymentAchCheckStatus(payment) {
  if (!payment) {
    return '';
  }

  if (payment.source === 'ACH') {
    if (!payment._billcom_receivedpay) {
      return 'Not started';
    }

    if (payment._billcom_receivedpay.status !== 'Paid') {
      return payment._billcom_receivedpay.status;
    }

    switch (payment._billcom_settlement?._billcom_settlement_parent?.status) {
      case '':
      case null:
      case undefined:
      case 'Sent':
        return 'Scheduled';
      case 'Voided':
        return 'Void';
      case 'Confirmed':
        return 'Confirmed';
      default:
        return 'Scheduled';
    }
  }

  if (payment.source === 'Check') {
    return payment.check_cleared ? 'Deposited' : 'Pending';
  }

  return '';
}
